import { useEffect, useState } from 'react';
import { hysteriFetch } from 'hysterics';
import { useRequestData } from 'wsm-common-data';

const NR_PREFIX = 'MYCARS_LANDING';
const ENDPOINT_FETCH_ERROR = `${NR_PREFIX}/CLIENT/VEHICLES_ENDPOINT_FETCH_ERROR`;

const vehicleDataService = hysteriFetch('vehicleData', {
	timeout: {
		timeout: 2000
	}
});

export const useFetchVehicleData = ({ vehicleId, siteId, accountId }) => {
	const { deviceType, locale } = useRequestData();
	const [response, setResponse] = useState(null);
	const [error, setError] = useState(null);

	const fetchVehicleData = async () => {
		const requestUrl = `/api/widget/ws-mycars-landing/vehicles/${vehicleId}`;

		const requestBody = {
			vehicleId,
			locale,
			deviceType: deviceType?.toLowerCase(),
			siteId,
			accountId
		};

		const requestBodyStringified = JSON.stringify(requestBody);

		let inventoryResponse;

		try {
			inventoryResponse = await vehicleDataService(requestUrl, {
				method: 'POST',
				headers: {
					'content-type': 'application/json;charset=UTF-8'
				},
				body: requestBodyStringified
			});

			setResponse(inventoryResponse);
		} catch (e) {
			setError(e);
			throw new Error(`${ENDPOINT_FETCH_ERROR}: ${e.message}`);
		}
	};

	useEffect(() => {
		if (vehicleId) {
			fetchVehicleData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [vehicleId]);

	return { response, error };
};
